<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { slide } from "svelte/transition";
  import { getContext } from "svelte";
  import TextInput from "../UI/TextInput.svelte";
  import Dialog from "../UI/Dialog.svelte";
  import PilotDialog from "../UI/PilotDialog.svelte";
  import Datepicker from "../CalendarComponents/Datepicker.svelte";
  import LoadingSpinner from "../UI/LoadingSpinner.svelte";
  import {
    REQUIRED_INFORMATION_MESSAGE,
    REQUIRED_SERVICE_PROVIDED,
    ALARMS_WORKING_EXCEED_PRE_EXISTING_ALARMS,
    YOUTH_SHOULD_NOT_BE_EQUAL_PEOPLE_SERVED,
    ERROR_PEOPLE_SERVED,
    SUM_YOU_THAN_SENIORS_NOT_GREATER_THAN,
    INDIVIDUALS_DISABILITIES,
    MILITARY_SHOULD_NOT_EXCEED_PEOPLESERVED,
    VALIDE_MAIL_MESSAGE,
    VALIDE_PHONE_MESSAGE,
    VALID_ADDRESS_MESSAGE,
    REVIEW_FIELDS_MARKED_RED,
    ERROR_OCCURRED_MESSAGE,
    NO_RECORD_FOUND,
    INVALID_ADD_NO_STREET,
    HFC_IN_HOME_VISIT,
    REMOTE_HFC_SERVICE_DELIVERY,
    PILOT_PROGRAM,
    SERVICE_ACKNOWLEDGMENT_FORM,
    PARTNER_DIRECT_SERVICE_ACKNOWLEDGMENT_FORM,
    MESSAGE_CLOSE_WINDOW,
    ADDRESS_VERIFIED,
    VERIFY_ADDRESS,
    YES,
    NO,
    BUTTON_COLOR_IS_SUCCESS,
    BUTTON_COLOR_IS_DANGER_LIGHT,
    GOOGLE_STREET_NUMBER_KEY,
    GOOGLE_ROUTE_KEY,
    GOOGLE_CITY_KEY,
    GOOGLE_CITY_KEY_2,
    GOOGLE_CITY_KEY_3,
    GOOGLE_CITY_KEY_4,
    GOOGLE_POSTAL_CODE_KEY,
    GOOGLE_STATE_CODE_NAME_KEY,
    GOOGLE_COUNTY_CODE_NAME_KEY,
    getCalendarInformationMessage,
    PILOT_CODE,
  } from "../Helpers/constants.js";
  import {
    isEmpty,
    isEmptyOrCero,
    isValidEmail,
    isValidZipCode,
    onlyNumeric,
    onlyNumericAndDash,
    isValidDhhSerialNumber,
    isWildfireServiceValid,
    isWildfireReferPartnerValid,
    formatPhoneNumber,
    validateAlarmsWorkingAndPreExistinAlarms,
    validateYouthServed,
    validateSeniorsServed,
    validateIdafnServed,
    validateMilitaryServed,
  } from "../Helpers/validation.js";
  import {
    states,
    numericDropDownValues,
    yesNoValuesDropdown,
    hazardValuesDropdown,
    nationalPartnerTypeDropdown,
    localPartnerTypeDropdown,
    switchIdBTextValue,
    getTextFromDropDown,
  } from "../Helpers/dropdownvalues.js";
  import {
    getAddressComponent,
    getAddressComponentWithSublocations,
    getFormattedAddress,
    callVerification,
  } from "../Helpers/checkaddress.js";
  import { section } from "../Helpers/sections.js";
  import { fly } from "svelte/transition";

  //loading the form at the top
  onMount(() => window.scrollTo(0, 0));
  const { open } = getContext("simple-modal");
  const HFC_URL = HFC_API_URL;

  $: isSubmitted = false;
  $: isLoading = "";
  $: selectedDate = new Date();
  const OCTOBER_1ST_2014 = new Date(2014, 9, 1);
  const dispatch = createEventDispatcher();
  // Cloning the object to have a clean form after each execution
  let sections = JSON.parse(JSON.stringify(section));
  let pilotSubmitBlocked = false;
  // google variables
  let googleformattedAddress = "";
  let googleStreetNumber = "";
  let googleRoute = "";
  let googleStreetNumberPlusRoute = "";
  let googleCity = "";
  let googleCounty = "";
  let googleState = "";
  let googlePostalCode = "";

  // 0 Service Acknowledgment Form Type
  let serviceTypeSelected = "";
  // 1 Service Acknowledgment Form Type
  let saftSelected = "";
  // 2 Home Address*
  let address = "";
  let apartment = "";
  let city = "";
  let zipcode = "";
  // to make zipCode reactive and allow only numbers in the UI
  $: zipCodeNumeric = onlyNumeric(zipcode);
  let stateSelected;
  let county = "";
  // 3 Service Provided*
  let alarmsInstalledSelected;
  let dhhAlarmsSelected;
  let strobeSmokeSelected;
  $: dhhSerialNumber = "";
  let batteriesReplacedSelected;
  let plansMadeSelected = "";
  let safetyChecklistSelected = "";
  let covidChecklistSelected = "";
  let localHazardTypeSelected;
  let documenterName = "";

  $: serviceDate = "";

  // Start New Pilot Program
  // WILDFIRE
  let wildfireLearnSelected = "";
  let wildfireEvacuationPlanSelected = "";
  let wildfireDefensibleSpaceSelected = "";
  let wildfireSignUpAlertSelected = "";
  let wildfireWeatherRadioSelected = "";
  let wildfireMagnetSelected = "";
  let wildfireRequestServiceSelected = "";
  let wildfireService = "";
  let wildfireReferHouseholdSelected = "";
  let wildfireReferPartner = "";
  //SAFEGIVE
  let installationsVerifiedSelected = "";
  // End New Pilot Program

  //4 Home Assessment*
  let preexistingAlarmsSelected;
  let preexistingAlarmsWorkingSelected;
  let peopleServedSelected;
  let youthServedSelected;
  let seniorsServedSelected;
  let idafnServedSelected;
  let militaryServedSelected;
  let additionalFollowUpSelected = "";
  let additionalNotes = "";
  //5 Partner Reporting Fields*
  let nationalPartnerSelected = "none";
  let localPartner = "";
  $: localPartnerTypeSelected = [];
  //6 Region Designated Reporting Fields
  let option1 = "";
  let option2 = "";
  let section6Touched = false;
  //7 Information for Future Follow Up*
  $: homePhone = "";
  $: cellPhone = "";
  $: homePhoneNumeric = onlyNumericAndDash(homePhone);
  $: cellPhoneNumeric = onlyNumericAndDash(cellPhone);

  let email = "";
  let section7Touched = false;
  //8 Administrative Section*
  $: dataEntryName = "";

  let calendarInformationMessage = REQUIRED_INFORMATION_MESSAGE;
  let promiseVerifyAddress = "";
  let promiseZipCode = "";

  // variables to determine if a field is valid

  // Section 0 Service Acknowledgment Form Type
  $: serviceTypeValid = !isEmpty(serviceTypeSelected);
  // if any of these values are modified, it will validate the fields of the section
  $: if (serviceTypeValid) {
    validateSection0();
  }
  function validateSection0() {
    if (serviceTypeValid) {
      sections[0].isSectionValidaded = true;
    } else {
      sections[0].isSectionValidaded = false;
    }
    validateForm(sections[0].id, false);
  }
  // Section 1 Service Acknowledgment Form Type
  $: saftSelectedValid = !isEmpty(saftSelected);
  // if any of these values are modified, it will validate the fields of the section
  $: if (saftSelectedValid) {
    validateSection1();
  }
  function validateSection1() {
    if (saftSelectedValid) {
      sections[1].isSectionValidaded = true;
    } else {
      sections[1].isSectionValidaded = false;
    }
    validateForm(sections[1].id, false);
  }

  // Section 2 Home Address*
  $: addressValid = !isEmpty(address);
  $: apartmentValid = !isEmpty(apartment);
  $: cityValid = !isEmpty(city);
  $: zipcodeValid = isValidZipCode(zipCodeNumeric);
  $: stateValid = !isEmpty(stateSelected);
  $: countyValid = !isEmpty(county);
  // if any of these values are modified, it will validate the fields of the section
  $: if (
    addressValid ||
    cityValid ||
    zipcodeValid ||
    stateValid ||
    countyValid ||
    apartment
  ) {
    validateSection2();
    apartment = apartment.toUpperCase();
  }
  // in case any address value is changed after the google address validation, the confirmed address will be removed
  $: if (
    showIconConfirmedAddress &&
    (address !== googleStreetNumberPlusRoute ||
      city !== googleCity ||
      zipcode !== googlePostalCode ||
      stateSelected !== googleState ||
      (googleCounty && county !== googleCounty))
  ) {
    setRejectAddress();
  }

  function validateSection2() {
    addressValid = !isEmpty(address);
    apartmentValid = !isEmpty(apartment);
    cityValid = !isEmpty(city);
    zipcodeValid = isValidZipCode(zipCodeNumeric);
    stateValid = !isEmpty(stateSelected);
    countyValid = !isEmpty(county);
    if (
      addressValid &&
      apartmentValid &&
      cityValid &&
      zipcodeValid &&
      stateValid &&
      countyValid
    ) {
      sections[2].isSectionValidaded = true;
    } else {
      sections[2].isSectionValidaded = false;
    }
    validateForm(sections[2].id, false);
  }

  // Section 3 Service Provided*
  $: alarmsInstalledValid = !isEmpty(alarmsInstalledSelected);
  $: dhhAlarmsValid = !isEmpty(dhhAlarmsSelected);
  $: strobeSmokeValid = !isEmpty(strobeSmokeSelected);
  $: dhhSerialNumberValid = false;
  $: batteriesReplacedValid = !isEmpty(batteriesReplacedSelected);
  $: plansMadeValid = !isEmpty(plansMadeSelected);
  $: safetyChecklistValid = !isEmpty(safetyChecklistSelected);

  // Start New Pilot Program
  $: isWildfireLearnValid = !isEmpty(wildfireLearnSelected);
  $: isWildfireEvacuationPlanValid = !isEmpty(wildfireEvacuationPlanSelected);
  $: isWildfireDefensibleSpaceValid = !isEmpty(wildfireDefensibleSpaceSelected);

  $: isWildfireSignUpAlertValid = !isEmpty(wildfireSignUpAlertSelected);
  $: isWildfireWeatherRadioValid = !isEmpty(wildfireWeatherRadioSelected);
  $: isWildfireMagnetValid = !isEmpty(wildfireMagnetSelected);
  $: isWildfireRequestServiceValid = !isEmpty(wildfireRequestServiceSelected);
  $: wildfireServiceValid = isWildfireServiceValid(
    serviceTypeSelected,
    pilotStatus,
    pilotCode,
    wildfireRequestServiceSelected,
    wildfireService
  );
  $: isWildfireReferHouseholdValid = !isEmpty(wildfireReferHouseholdSelected);
  $: wildfireReferPartnerValid = isWildfireReferPartnerValid(
    serviceTypeSelected,
    pilotStatus,
    pilotCode,
    wildfireReferHouseholdSelected,
    wildfireReferPartner
  );

  $: isInstallationsVerifiedValid = !isEmpty(installationsVerifiedSelected);

  // End New Pilot Program
  /* $: covidChecklistValid = !isEmpty(covidChecklistSelected); */
  $: localHazardTypeValid = !isEmpty(localHazardTypeSelected);
  $: documenterNameValid = !isEmpty(documenterName);
  // calendar will change to isServiceDateChosen = true once the user picks a date
  $: isServiceDateChosen = false;
  $: isvalidDate = false;
  // serviceProvidedValid : this validation belongs to some field from sections 3 and 4 at the same time
  // Prevent records from being submitted where no service is provided.
  // Must have at least one of the following: alarm installed (any), DHH requested, pre-existing alarm tested and working, battery replaced, escape plan made, fire safety checklist completed.
  $: serviceProvidedValid = false;
  // $: additionalNotesValid = !isEmpty(additionalNotes);
  // if any of these values are modified, it will validate the fields of the section
  // if any of these values are modified, it will validate the fields of the section
  $: if (
    pilotCode ||
    alarmsInstalledSelected ||
    dhhAlarmsValid ||
    dhhAlarmsSelected ||
    dhhSerialNumber ||
    batteriesReplacedSelected ||
    plansMadeSelected ||
    safetyChecklistSelected ||
    /* covidChecklistSelected || */
    localHazardTypeSelected ||
    documenterName ||
    isServiceDateChosen ||
    isvalidDate ||
    serviceDate
  ) {
    dhhSerialNumberValid = isValidDhhSerialNumber(
      dhhAlarmsValid,
      dhhSerialNumber,
      dhhAlarmsSelected
    );
    serviceProvidedValid = validateServiceProvider();
    validateDate();
    validateSection3();
    validateSection4();
    dhhSerialNumber = dhhSerialNumber.toUpperCase();
  }
  function validateServiceProvider() {
    serviceProvidedValid =
      !isEmptyOrCero(alarmsInstalledSelected) ||
      !isEmptyOrCero(dhhAlarmsSelected) ||
      !isEmptyOrCero(batteriesReplacedSelected) ||
      (plansMadeValid && plansMadeSelected === "Yes") ||
      (safetyChecklistValid && safetyChecklistSelected === "Yes") ||
      !isEmptyOrCero(preexistingAlarmsSelected) ||
      !isEmptyOrCero(preexistingAlarmsWorkingSelected) ||
      pilotCode === PILOT_CODE.WILDFIRE;

    return serviceProvidedValid;
  }
  function validateDate() {
    let dateChosen = new Date(serviceDate);
    // to allow the calendar to keep the date
    if (isServiceDateChosen) {
      selectedDate = dateChosen;
    }
    if (isServiceDateChosen && OCTOBER_1ST_2014 <= dateChosen) {
      isvalidDate = true;
    }
    if (isServiceDateChosen && dateChosen < OCTOBER_1ST_2014) {
      calendarInformationMessage =
        getCalendarInformationMessage(OCTOBER_1ST_2014);
      isvalidDate = false;
    }
  }
  function validateSection3() {
    if (
      alarmsInstalledValid &&
      dhhAlarmsValid &&
      dhhSerialNumberValid &&
      strobeSmokeValid &&
      batteriesReplacedValid &&
      plansMadeValid &&
      safetyChecklistValid &&
      /* covidChecklistValid && */
      localHazardTypeValid &&
      documenterNameValid &&
      isvalidDate &&
      serviceProvidedValid &&
      validatePilotProgram()
    ) {
      sections[3].isSectionValidaded = true;
    } else {
      sections[3].isSectionValidaded = false;
    }
    validateForm(sections[3].id, false);
  }

  function validatePilotProgram() {
    if (validateWildfire() && validateSafegive()) {
      return true;
    }
  }

  function validateWildfire() {
    if (
      serviceTypeSelected !== PILOT_PROGRAM ||
      (serviceTypeSelected === PILOT_PROGRAM &&
        pilotCode !== PILOT_CODE.WILDFIRE) ||
      (serviceTypeSelected === PILOT_PROGRAM &&
        pilotStatus === 1 &&
        pilotCode === PILOT_CODE.WILDFIRE &&
        isWildfireLearnValid &&
        isWildfireEvacuationPlanValid &&
        isWildfireDefensibleSpaceValid &&
        isWildfireSignUpAlertValid &&
        isWildfireWeatherRadioValid &&
        isWildfireMagnetValid &&
        isWildfireRequestServiceValid &&
        wildfireServiceValid &&
        isWildfireReferHouseholdValid &&
        wildfireReferPartnerValid)
    ) {
      return true;
    }
  }

  function validateSafegive() {
    if (
      serviceTypeSelected !== PILOT_PROGRAM ||
      (serviceTypeSelected === PILOT_PROGRAM &&
        pilotCode !== PILOT_CODE.SAFEGIVE) ||
      (serviceTypeSelected === PILOT_PROGRAM &&
        pilotStatus === 1 &&
        pilotCode === PILOT_CODE.SAFEGIVE &&
        installationsVerifiedSelected)
    ) {
      return true;
    }
  }

  // Section 4 Home Assessment*

  // $: preexistingAlarmsValid = !isEmpty(preexistingAlarmsSelected);
  $: preexistingAlarmsWorkingValid = false;
  $: peopleServedValid = !isEmpty(peopleServedSelected);
  $: youthServedValid = false;
  $: seniorsServedValid = false;
  $: idafnServedValid = false;
  $: militaryServedValid = false;
  $: additionalFollowUpValid = false;

  $: if (
    peopleServedSelected ||
    youthServedSelected ||
    seniorsServedSelected ||
    idafnServedSelected ||
    militaryServedSelected ||
    preexistingAlarmsSelected ||
    preexistingAlarmsWorkingSelected ||
    additionalFollowUpSelected ||
    serviceTypeSelected
  ) {
    youthServedValid = validateYouthServed(
      peopleServedSelected,
      youthServedSelected
    );
    additionalFollowUpValid =
      isEmpty(serviceTypeSelected) ||
      serviceTypeSelected === HFC_IN_HOME_VISIT ||
      serviceTypeSelected === PILOT_PROGRAM ||
      (!isEmpty(additionalFollowUpSelected) &&
        serviceTypeSelected === REMOTE_HFC_SERVICE_DELIVERY);
    seniorsServedValid = validateSeniorsServed(
      peopleServedSelected,
      youthServedSelected,
      seniorsServedSelected
    );
    idafnServedValid = validateIdafnServed(
      peopleServedSelected,
      idafnServedSelected
    );
    militaryServedValid = validateMilitaryServed(
      peopleServedSelected,
      militaryServedSelected
    );
    preexistingAlarmsWorkingValid = validateAlarmsWorkingAndPreExistinAlarms(
      preexistingAlarmsSelected,
      preexistingAlarmsWorkingSelected
    );
    serviceProvidedValid = validateServiceProvider();
    validateSection3();
    validateSection4();
    validateAdditionalFollowUp();
  }
  function validateAdditionalFollowUp() {
    if (serviceTypeSelected !== REMOTE_HFC_SERVICE_DELIVERY) {
      additionalFollowUpSelected = "";
    }
  }

  function validateSection4() {
    if (
      peopleServedValid &&
      youthServedValid &&
      seniorsServedValid &&
      idafnServedValid &&
      militaryServedValid &&
      serviceProvidedValid &&
      additionalFollowUpValid &&
      preexistingAlarmsWorkingValid
    ) {
      sections[4].isSectionValidaded = true;
    } else {
      sections[4].isSectionValidaded = false;
    }
    validateForm(sections[4].id, false);
  }

  // Section 5 Partner Reporting Fields*
  $: nationalPartnerValid = !isEmpty(nationalPartnerSelected);
  $: localPartnerNameValid =
    localPartnerTypeSelected.length === 0 ||
    (localPartnerTypeSelected.includes("none") &&
      localPartnerTypeSelected.length === 1) ||
    !isEmpty(localPartner);
  $: localPartnerTypeValid = localPartnerTypeSelected.length > 0;
  // if any of these values are modified, it will validate the fields of the section

  $: if (
    nationalPartnerValid ||
    localPartnerTypeValid ||
    localPartnerNameValid
  ) {
    validateSection5();
  }
  function validateSection5() {
    if (
      nationalPartnerValid &&
      localPartnerTypeValid &&
      localPartnerNameValid
    ) {
      sections[5].isSectionValidaded = true;
    } else {
      sections[5].isSectionValidaded = false;
    }
    validateForm(sections[5].id, false);
  }

  // Section 6 Region Designated Reporting Fields
  //5 Region Designated Reporting Fields
  $: option1Valid = !isEmpty(option1);
  $: option2Valid = !isEmpty(option2);
  $: if (isSaveTriggered || section6Touched || option1 || option2) {
    validateSection6();
  }
  function validateSection6() {
    if (isSaveTriggered || section6Touched || option1Valid || option2Valid) {
      sections[6].isSectionValidaded = true;
    } else {
      sections[6].isSectionValidaded = false;
    }
    validateForm(sections[6].id, false);
  }

  // Section 7 Information for Future Follow Up*
  $: emailValid = isEmpty(email) || (!isEmpty(email) && isValidEmail(email));
  $: homePhoneValid =
    isEmpty(homePhone) ||
    (!isEmpty(homePhone) && onlyNumeric(homePhone).length === 10);
  $: cellPhoneValid =
    isEmpty(cellPhone) ||
    (!isEmpty(cellPhone) && onlyNumeric(cellPhone).length === 10);
  $: if (
    email ||
    section7Touched ||
    isSaveTriggered ||
    email ||
    homePhone ||
    cellPhone
  ) {
    section7Touched = true;
    validateSection7();
    formatPhone(homePhone);
    formatCellPhone(cellPhone);
  }
  function formatPhone(phoneNumberString) {
    if (phoneNumberString.length >= 3) {
      homePhoneNumeric = formatPhoneNumber(phoneNumberString);
    }
  }

  function formatCellPhone(phoneNumberString) {
    if (phoneNumberString.length >= 3) {
      cellPhoneNumeric = formatPhoneNumber(phoneNumberString);
    }
  }
  function validateSection7() {
    if (
      emailValid &&
      homePhoneValid &&
      cellPhoneValid &&
      (section7Touched || isSaveTriggered)
    ) {
      sections[7].isSectionValidaded = true;
    } else {
      sections[7].isSectionValidaded = false;
    }
    if (!emailValid) {
      sections[7].isSectionValidaded = false;
    }
    validateForm(sections[7].id, false);
  }

  // Section 8 Administrative Section*
  $: dataEntryNameValid = !isEmpty(dataEntryName);
  // if any of these values are modified, it will validate the fields of the section
  $: if (dataEntryName) {
    validateSection8();
  }
  function validateSection8(dataEntryName) {
    if (!isEmpty(dataEntryName)) {
      sections[8].isSectionValidaded = true;
    } else {
      sections[8].isSectionValidaded = false;
    }
    validateForm(sections[8].id, false);
  }

  // validates the entire sections

  let formIsValid = false;
  let isSaveTriggered = false;

  function validateForm(sectionId, iterateList) {
    formIsValid =
      sections[0].isSectionValidaded &&
      sections[1].isSectionValidaded &&
      sections[2].isSectionValidaded &&
      sections[3].isSectionValidaded &&
      sections[4].isSectionValidaded &&
      sections[5].isSectionValidaded &&
      sections[6].isSectionValidaded &&
      sections[7].isSectionValidaded &&
      sections[8].isSectionValidaded;
    changeColorAndIcon(sectionId, iterateList);
    return formIsValid;
  }

  function submit() {
    isSaveTriggered = true;
    validateSection6();
    validateSection7();
    if (validateForm(8, true)) {
      isSubmitted = true;
      isLoading = "is-loading";
      submitForm();
    } else {
      return false;
    }
  }

  // enables or disables the sections according to the input
  const expand = (sectionId) => {
    sections = sections.map((s) => {
      if (s.id === sectionId) {
        s.active = !s.active;
      }
      return s;
    });
  };

  // changes the color and the icon of the accordion of only 1 section
  function changeColorAndIcon(sectionId, iterateList) {
    sections[sectionId].buttonIcon = "<i class='fas fa-ellipsis-h'></i>";

    if (sections[sectionId].isSectionValidaded) {
      sections[sectionId].buttonColor = "is-rounded is-success";
      sections[sectionId].buttonIcon = "<i class='fas fa-check'></i>";
    }
    if (!sections[sectionId].isSectionValidaded) {
      (sections[sectionId].buttonColor = "is-rounded is-danger is-light"),
        (sections[sectionId].buttonIcon = "<i class='fas fa-ellipsis-h'></i>");
    }
    // if iterateList == true will change all the colors and icons of all sections
    if (iterateList) {
      for (let a = 0; a < sections.length; a++) {
        let part = sections[a];
        if (sections[a].isSectionValidaded) {
          sections[a].buttonColor = "is-rounded is-success";
          sections[a].buttonIcon = "<i class='fas fa-check'></i>";
        }
        if (!sections[a].isSectionValidaded) {
          sections[a].buttonColor = "is-rounded is-danger";
          sections[a].buttonIcon = "<i class='fas fa-exclamation'></i>";
        }
      }
    }
  }

  function submitForm() {
    //isSubmitted = true;
    //isLoading = "is-loading";

    // Sending the value instead of the id
    localPartnerTypeSelected = switchIdBTextValue(
      localPartnerTypeSelected,
      localPartnerTypeDropdown
    );
    nationalPartnerSelected = getTextFromDropDown(
      nationalPartnerSelected,
      nationalPartnerTypeDropdown
    );
    localHazardTypeSelected = getTextFromDropDown(
      localHazardTypeSelected,
      hazardValuesDropdown
    );
    additionalFollowUpSelected = !isEmpty(additionalFollowUpSelected)
      ? additionalFollowUpSelected
      : "NA";

    //prepares the data and fields to be sent
    const recordData = {
      // 0 Service  Type
      serviceType: serviceTypeSelected,
      // 1 Service Acknowledgment Form Type
      reportingForm: saftSelected,
      // 2 Home Address*
      addressLine1: address,
      addressLine2: apartment,
      city: city,
      state: stateSelected,
      zipcode: zipCodeNumeric,
      county: county,
      verifiedAddress: showIconConfirmedAddress,
      // 3 Service Provided*
      alarmsInstalled: alarmsInstalledSelected,
      dhhAlarms: dhhAlarmsSelected,
      dhhSerialNumber: dhhSerialNumber,
      strobeSmoke: strobeSmokeSelected,
      batteriesReplaced: batteriesReplacedSelected,
      plansMade: plansMadeSelected,
      safetyChecklist: safetyChecklistSelected,
      covidChecklist: covidChecklistSelected,
      localHazardType: localHazardTypeSelected,
      documenterName: documenterName,
      serviceDate: serviceDate,
      // Start New Pilot Program
      pilotType: pilotCode,
      pilotCode: pilotValue,
      // WILDFIRE
      wildfireLearn: wildfireLearnSelected,
      wildfireEvacuationPlan: wildfireEvacuationPlanSelected,
      wildfireDefensibleSpace: wildfireDefensibleSpaceSelected,
      wildfireSignUpAlert: wildfireSignUpAlertSelected,
      wildfireWeatherRadio: wildfireWeatherRadioSelected,
      wildfireMagnet: wildfireMagnetSelected,
      wildfireRequestService: wildfireRequestServiceSelected,
      wildfireService: wildfireService,
      wildfireReferHousehold: wildfireReferHouseholdSelected,
      wildfireReferPartner: wildfireReferPartner,
      //SAFEGIVE
      SavegiveInstallationsVerified: installationsVerifiedSelected,
      // End New Pilot Program
      //4 Home Assessment*
      preexistingAlarms: preexistingAlarmsSelected,
      preexistingAlarmsWorking: preexistingAlarmsWorkingSelected,
      peopleServed: peopleServedSelected,
      youthServed: youthServedSelected,
      seniorsServed: seniorsServedSelected,
      idafnServed: idafnServedSelected,
      militaryServed: militaryServedSelected,
      additionalFollowUp: additionalFollowUpSelected,
      additionalNotes: additionalNotes,
      //5 Partner Reporting Fields*
      nationalPartner: nationalPartnerSelected,
      localPartner: localPartner,
      localPartnerType: localPartnerTypeSelected,
      //6 Region Designated Reporting Fields
      option1: option1,
      option2: option2,
      //7 Information for Future Follow Up*
      homePhone: homePhone,
      cellPhone: cellPhone,
      email: email,
      //8 Administrative Section*
      dataEntryName: dataEntryName
    };

    fetch(HFC_URL, {
      method: "POST",
      body: JSON.stringify({ ...recordData }),
      headers: { "Content-Type": "application/json" }
    })
      .then((res) => {
        if (!res.ok) {
          dispatch("error");
          throw new Error(ERROR_OCCURRED_MESSAGE);
        } else {
          dispatch("save");
        }
        return res.json();
      })
      .catch((err) => {
        dispatch("error");
        console.log(err);
      });
  }

  function cancel() {
    dispatch("cancel");
  }

  function verifyAddress() {
    if (!isEmpty(address) && !isEmpty(city) && !isEmpty(stateSelected)) {
      const completeAddress = address + "," + city + "," + stateSelected;
      promiseVerifyAddress = callVerification(
        HFC_URL,
        "address",
        completeAddress
      );
    }
  }

  let showSetAddressButton = false;
  let showIconConfirmedAddress = false;
  $: vefiriedAddressButtonColor = showIconConfirmedAddress
    ? BUTTON_COLOR_IS_SUCCESS
    : BUTTON_COLOR_IS_DANGER_LIGHT;
  $: vefiriedAddress = showIconConfirmedAddress
    ? ADDRESS_VERIFIED
    : VERIFY_ADDRESS;
  $: calendarButtonColor = isServiceDateChosen
    ? BUTTON_COLOR_IS_SUCCESS
    : BUTTON_COLOR_IS_DANGER_LIGHT;

  function getGoogleAddress(response) {
    googleformattedAddress = getFormattedAddress(response);
    googleStreetNumber = getAddressComponent(
      response,
      GOOGLE_STREET_NUMBER_KEY
    );
    googleRoute = getAddressComponent(response, GOOGLE_ROUTE_KEY);
    googleCity = getAddressComponent(response, GOOGLE_CITY_KEY);
    googleCity = isEmpty(googleCity)
      ? getAddressComponentWithSublocations(response, GOOGLE_CITY_KEY_2)
      : googleCity;
    googleCity = isEmpty(googleCity)
      ? getAddressComponent(response, GOOGLE_CITY_KEY_3)
      : googleCity;
    googleCity = isEmpty(googleCity)
      ? getAddressComponent(response, GOOGLE_CITY_KEY_4)
      : googleCity;
    googleCounty = getAddressComponent(response, GOOGLE_COUNTY_CODE_NAME_KEY);
    googleState = getAddressComponent(response, GOOGLE_STATE_CODE_NAME_KEY);
    googlePostalCode = getAddressComponent(response, GOOGLE_POSTAL_CODE_KEY);
    googleStreetNumberPlusRoute = !isEmpty(googleStreetNumber)
      ? googleStreetNumber + " " + googleRoute
      : googleRoute;
    showSetAddressButton = true;
    showIconConfirmedAddress = false;
    if (!googleRoute || !googleformattedAddress) {
      googleformattedAddress = NO_RECORD_FOUND;
    }
    if (isEmpty(googleStreetNumber)) {
      googleformattedAddress = INVALID_ADD_NO_STREET;
    }
    return "";
  }

  function setRejectAddress() {
    showSetAddressButton = false;
    showIconConfirmedAddress = false;
    googleformattedAddress = "";
  }

  function setGoogleAddress() {
    address = googleStreetNumberPlusRoute;
    city = googleCity;
    zipcode = googlePostalCode;
    stateSelected = googleState;
    county = googleCounty ? googleCounty : county;
    googleformattedAddress = "";
    showSetAddressButton = false;
    showIconConfirmedAddress = true;
  }
  // this verifies the zip code against google geocode API
  function validateZipCode(code) {
    zipcode = code;
    if (zipcodeValid) {
      const zipCodeUrl = zipCodeNumeric + "+USA";
      promiseZipCode = callVerification(HFC_URL, "address", zipCodeUrl);
    }
    //return zipcode;
  }

  function validateNumericHomePhone(number) {
    if (
      number.length > homePhone.length ||
      (number.length !== 3 && number.length !== 7)
    ) {
      homePhone = number;
    }
  }
  function validateNumericCellPhone(number) {
    if (
      number.length > cellPhone.length ||
      (number.length !== 3 && number.length !== 7)
    ) {
      cellPhone = number;
    }
  }

  function AutocompleteCountyAndState(response) {
    stateSelected = getAddressComponent(response, GOOGLE_STATE_CODE_NAME_KEY);
    county = getAddressComponent(response, GOOGLE_COUNTY_CODE_NAME_KEY);
    city = getAddressComponent(response, GOOGLE_CITY_KEY);
    city = isEmpty(city)
      ? getAddressComponentWithSublocations(response, GOOGLE_CITY_KEY_2)
      : city;
    city = isEmpty(city)
      ? getAddressComponent(response, GOOGLE_CITY_KEY_3)
      : city;
    stateSelected = !isEmpty(stateSelected) ? stateSelected : "";
    county = !isEmpty(county) ? county : "";
    city = !isEmpty(city) ? city : "";
    return "";
  }

  function serviceType(type) {
    if (type === HFC_IN_HOME_VISIT || type === REMOTE_HFC_SERVICE_DELIVERY) {
      cleanPilotProgram();
      pilotCode = "";
      pilotValue = "";
    }
    if (type === PILOT_PROGRAM) {
      showPilotDialog();
    }
  }

  function cleanPilotProgram() {
    wildfireLearnSelected = "";
    wildfireEvacuationPlanSelected = "";
    wildfireDefensibleSpaceSelected = "";
    wildfireSignUpAlertSelected = "";
    wildfireWeatherRadioSelected = "";
    wildfireMagnetSelected = "";
    wildfireRequestServiceSelected = "";
    wildfireService = "";
    wildfireReferHouseholdSelected = "";
    wildfireReferPartner = "";
    installationsVerifiedSelected = "";

    let wildfireRadioButton = [
      "wildfireLearn",
      "wildfireEvacuationPlan",
      "wildfireDefensibleSpace",
      "wildfireSignUpAlert",
      "wildfireWeatherRadio",
      "wildfireMagnet",
      "wildfireRequestService",
      "wildfireReferHousehold",
      "installationsVerified",
    ];

    wildfireRadioButton.forEach((element) => resetRadioButton(element));
  }

  function resetRadioButton(name) {
    var ele = document.getElementsByName(name);
    for (var i = 0; i < ele.length; i++) {
      ele[i].checked = false;
    }
  }

  // to habilitate sections with no required fields
  function sectionTouched(id) {
    if (id === 6) {
      section6Touched = true;
    }
    if (id === 7) {
      section7Touched = true;
    }
    expand(id);
  }

  var expanded = false;

  const onCancel = (text) => {
    cancel();
  };

  const onOkay = (text) => {};

  const showDialog = () => {
    open(
      Dialog,
      {
        message: MESSAGE_CLOSE_WINDOW,
        onCancel,
        onOkay,
      },
      {
        closeButton: false,
        closeOnEsc: false,
        closeOnOuterClick: false,
      }
    );
  };

  let pilotCode = "";
  let pilotValue = "";
  let pilotStatus = 0;

  const onCancelPilot = (text) => {
    cleanPilotProgram();
    pilotSubmitBlocked = text;
    pilotCode = "";
    pilotStatus = -1;
    serviceTypeSelected = "";
    serviceTypeValid = false;
    validateSection0();
    (sections[0].buttonColor = "is-rounded is-danger is-light"),
      (sections[0].buttonIcon = "<i class='fas fa-ellipsis-h'></i>");
  };

  const onOkayPilot = (code, value) => {
    pilotCode = code;
    pilotValue = value;
    pilotStatus = 1;
    cleanPilotProgram();
  };

  const showPilotDialog = () => {
    open(
      PilotDialog,
      {
        message: "Enter Pilot Code",
        hasForm: true,
        blocked: pilotSubmitBlocked,
        onCancelPilot,
        onOkayPilot,
      },
      {
        closeButton: false,
        closeOnEsc: false,
        closeOnOuterClick: false,
      }
    );
  };
</script>

<body>
  <section class="section">
    <div class="container">
      <form form on:submit|preventDefault={submitForm}>
        <!-- Section 0 Service Type -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[0].buttonColor}"
            on:click|preventDefault={() => expand(sections[0].id)}
          >
            <span style="font-weight:bold">{sections[0].title}</span>
            <span class="icon">
              {@html sections[0].buttonIcon}
            </span>
          </button>

          {#if sections[0].active}
            <section class="section">
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>
                    What type of service was provided to this client?
                  </strong>
                </label>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="hfc_in_home_visit"
                    type="radio"
                    on:click={() => serviceType(HFC_IN_HOME_VISIT)}
                    value={HFC_IN_HOME_VISIT}
                    bind:group={serviceTypeSelected}
                    name="servicetype"
                  />
                  <label for="hfc_in_home_visit">{HFC_IN_HOME_VISIT}</label>
                </div>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="remote_hfc_service_delivery"
                    type="radio"
                    on:click={() => serviceType(REMOTE_HFC_SERVICE_DELIVERY)}
                    value={REMOTE_HFC_SERVICE_DELIVERY}
                    bind:group={serviceTypeSelected}
                    name="servicetype"
                  />
                  <label for="remote_hfc_service_delivery">
                    {REMOTE_HFC_SERVICE_DELIVERY}
                  </label>
                </div>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="pilot_program"
                    type="radio"
                    on:click={() => serviceType(PILOT_PROGRAM)}
                    value={PILOT_PROGRAM}
                    bind:group={serviceTypeSelected}
                    name="servicetype"
                  />
                  <label for="pilot_program">
                    {PILOT_PROGRAM}
                  </label>
                </div>
                {#if !serviceTypeValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
            </section>
          {/if}
          <br />
        </div>
        <!-- Section 1 Service Acknowledgment Form Type -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[1].buttonColor}"
            on:click|preventDefault={() => expand(sections[1].id)}
          >
            <span style="font-weight:bold">{sections[1].title}</span>
            <span class="icon">
              {@html sections[1].buttonIcon}
            </span>
          </button>

          {#if sections[1].active}
            <section class="section">
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>Reporting Form Is Labeled</strong>
                </label>
                <label style="color:blue">
                  <small>
                    <i>
                      If using a paper form, what are the exact words found on
                      the top of the page? If doing live data entry, please
                      select “Service Acknowledgment Form” unless instructed
                      otherwise.
                    </i>
                  </small>
                </label>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="serviceacknowledgment"
                    type="radio"
                    value={SERVICE_ACKNOWLEDGMENT_FORM}
                    bind:group={saftSelected}
                    name="serviceacknowledgmentformtype"
                  />
                  <label for="serviceacknowledgment">
                    {SERVICE_ACKNOWLEDGMENT_FORM}
                  </label>
                </div>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="partnerdirectserviceacknowledgment"
                    type="radio"
                    value={PARTNER_DIRECT_SERVICE_ACKNOWLEDGMENT_FORM}
                    bind:group={saftSelected}
                    name="serviceacknowledgmentformtype"
                  />
                  <label for="partnerdirectserviceacknowledgment">
                    {PARTNER_DIRECT_SERVICE_ACKNOWLEDGMENT_FORM}
                  </label>
                </div>
                {#if !saftSelectedValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
            </section>
          {/if}
          <br />
        </div>
        <!-- Section 2 Home Address* -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[2].buttonColor}"
            on:click|preventDefault={() => expand(sections[2].id)}
          >
            <span style="font-weight:bold">{sections[2].title}</span>
            <span class="icon">
              {@html sections[2].buttonIcon}
            </span>
          </button>

          {#if sections[2].active}
            <section class="section">
              <div class="slider" transition:slide>
                <TextInput
                  id="zipcode"
                  label="Zip Code"
                  type="tel"
                  comment="(5-digits) Example: 20006"
                  onKeyUp={validateZipCode(zipCodeNumeric)}
                  placeholder="20006"
                  valid={!zipcodeValid && isSaveTriggered}
                  validityMessage={REQUIRED_INFORMATION_MESSAGE}
                  value={zipCodeNumeric}
                  on:input={(event) => (zipCodeNumeric = event.target.value)}
                />
              </div>
              {#await promiseZipCode}
                <LoadingSpinner />
              {:then response}
                <p>
                  {#if response}{AutocompleteCountyAndState(response)}{/if}
                </p>
              {/await}
              <div class="slider" transition:slide>
                <TextInput
                  id="address"
                  label="Address"
                  comment="Example: 2025 E Street NW"
                  placeholder="2025 E Street NW"
                  valid={!addressValid && isSaveTriggered}
                  validityMessage={VALID_ADDRESS_MESSAGE}
                  value={address}
                  on:input={(event) => (address = event.target.value)}
                />
              </div>
              <div class="slider" transition:slide>
                <TextInput
                  id="apartment"
                  label="Apartment or Mobile Home # "
                  comment="Mark 'NA' if not applicable"
                  placeholder="NA"
                  valid={!apartmentValid && isSaveTriggered}
                  validityMessage={REQUIRED_INFORMATION_MESSAGE}
                  value={apartment}
                  on:input={(event) => (apartment = event.target.value)}
                />
              </div>
              <div class="slider" transition:slide>
                <TextInput
                  id="city"
                  label="City "
                  valid={!cityValid && isSaveTriggered}
                  validityMessage={REQUIRED_INFORMATION_MESSAGE}
                  value={city}
                  on:input={(event) => (city = event.target.value)}
                />
              </div>
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>State</strong>
                </label>
                <br />
                <div class="select">
                  <select bind:value={stateSelected}>
                    {#each states as state}
                      <option value={state.id}>{state.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !stateValid && isSaveTriggered}
                  <p class="error-message">"Please Select a state"</p>
                {/if}
              </div>
              <br />

              <button
                class={vefiriedAddressButtonColor}
                on:click|preventDefault={() => verifyAddress()}
              >
                <span>{vefiriedAddress}</span>
              </button>
              {#await promiseVerifyAddress}
                <LoadingSpinner />
              {:then results}
                {#if results}{getGoogleAddress(results)}{/if}
                <br />
                <p>{googleformattedAddress}</p>
                <div>
                  <p>
                    {#if showSetAddressButton && googleformattedAddress !== NO_RECORD_FOUND && googleformattedAddress !== INVALID_ADD_NO_STREET}
                      <button
                        class="button is-small is-success is-bold"
                        on:click|preventDefault={() => setGoogleAddress()}
                      >
                        <span class="icon is-small">
                          <i class="fas fa-check" />
                        </span>
                        <span class="has-text-weight-bold">Choose</span>
                      </button>
                      <button
                        class="button is-small is-danger is-light"
                        on:click|preventDefault={() => setRejectAddress()}
                      >
                        <span class="has-text-weight-bold">Reject</span>
                        <span class="icon is-small">
                          <i class="fas fa-times" />
                        </span>
                      </button>
                    {/if}
                  </p>
                </div>
                <div>
                  <p>
                    {#if showIconConfirmedAddress}
                      <span class="icon has-text-success is-medium">
                        <i class="fas fa-2x fa-check-square" />
                      </span>
                      <span class="is-italic">Street Name Confirmed</span>
                    {/if}
                  </p>
                </div>
              {/await}
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="county"
                  label="County"
                  comment="To auto-populate please click Verify Address and
                  select the suggested address."
                  valid={!countyValid && isSaveTriggered}
                  validityMessage={REQUIRED_INFORMATION_MESSAGE}
                  value={county}
                  on:input={(event) => (county = event.target.value)}
                />
              </div>
            </section>
          {/if}
        </div>
        <!-- Section 3 Services Provided* -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[3].buttonColor}"
            on:click|preventDefault={() => expand(sections[3].id)}
          >
            <span style="font-weight:bold">{sections[3].title}</span>
            <span class="icon">
              {@html sections[3].buttonIcon}
            </span>
          </button>

          {#if !serviceProvidedValid && isSaveTriggered}
            <br />
            <p class="error-message">{REQUIRED_SERVICE_PROVIDED}</p>
            <br />
          {/if}

          {#if sections[3].active}
            <section class="section">
              <div class="slider" transition:slide>
                <label class="required">
                  <strong># of New Smoke Alarms Installed and Tested?</strong>
                </label>
                <span style="color:blue">
                  <small>
                    <i>
                      Enter the Number of New 10-Year and 9-Volt Alarms
                      Installed
                    </i>
                  </small>
                </span>
                <br />
                <div class="select">
                  <select bind:value={alarmsInstalledSelected}>
                    {#each numericDropDownValues(0, 9) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !alarmsInstalledValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label class="required">
                  <strong># of New Bed Shaker Alarms Installed (DHH)</strong>
                </label>
                <span style="color:blue">
                  <small>
                    <i>
                      Enter the Number of New Bed Shaker Alarms Installed for
                      Individuals Who are Deaf or Hard of Hearing
                    </i>
                  </small>
                </span>
                <br />
                <div class="select">
                  <select bind:value={dhhAlarmsSelected}>
                    {#each numericDropDownValues(0, 5) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !dhhAlarmsValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              {#if !isEmptyOrCero(dhhAlarmsSelected)}
                <div class="slider" transition:slide>
                  <TextInput
                    id="dhhSerialNumber"
                    label="Serial Numbers of Any New Bed Shaker Alarms Installed"
                    comment="Please enter serial numbers for bed shaker installs
                    (separate by a comma if more than one install), mark NA if
                    not applicable"
                    placeholder="NA"
                    disableRequiredAsterisk={dhhSerialNumberValid}
                    valid={!dhhSerialNumberValid && isSaveTriggered}
                    validityMessage={REQUIRED_INFORMATION_MESSAGE}
                    value={dhhSerialNumber}
                    on:input={(event) => (dhhSerialNumber = event.target.value)}
                  />
                </div>
                <br />
              {/if}
              <div class="slider" transition:slide>
                <label class="required">
                  <strong># of New Strobe Smoke Alarms Installed (DHH)</strong>
                </label>
                <span style="color:blue">
                  <small>
                    <i>
                      Enter the Number of New <u>Strobe Light</u> Smoke Alarms Installed
                      for Individuals Who are Deaf or Hard of Hearing
                    </i>
                  </small>
                </span>
                <br />
                <div class="select">
                  <select bind:value={strobeSmokeSelected}>
                    {#each numericDropDownValues(0, 5) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !strobeSmokeValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label class="required">
                  <strong># Batteries Replaced</strong>
                </label>
                <span style="color:blue">
                  <small>
                    <i>
                      Enter the number of 9-volt batteries replaced in
                      pre-existing alarms
                    </i>
                  </small>
                </span>
                <br />
                <div class="select">
                  <select bind:value={batteriesReplacedSelected}>
                    {#each numericDropDownValues(0, 9) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !batteriesReplacedValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>
                    Did the resident(s) create a fire escape plan?
                  </strong>
                </label>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="plansMadeYes"
                    type="radio"
                    value={YES}
                    bind:group={plansMadeSelected}
                    name="plansMade"
                  />
                  <label for="plansMadeYes">{YES}</label>
                  <input
                    class="is-checkradio is-circle is-success"
                    id="plansMadeNo"
                    type="radio"
                    value={NO}
                    bind:group={plansMadeSelected}
                    name="plansMade"
                  />
                  <label for="plansMadeNo">{NO}</label>
                </div>
                {#if !plansMadeValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>
                    Did the resident(s) review the Home Fire Safety Checklist?
                  </strong>
                </label>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="safetychecklistYes"
                    type="radio"
                    value={YES}
                    bind:group={safetyChecklistSelected}
                    name="safetychecklist"
                  />
                  <label for="safetychecklistYes">{YES}</label>
                  <input
                    class="is-checkradio is-circle is-success"
                    id="safetychecklistNo"
                    type="radio"
                    value={NO}
                    bind:group={safetyChecklistSelected}
                    name="safetychecklist"
                  />
                  <label for="safetychecklistNo">{NO}</label>
                </div>
                {#if !safetyChecklistValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              <!-- Field Disabled temporarily 
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>
                    Did the resident(s) review the COVID safety checklist?
                  </strong>
                </label>
                <br />
                <div class="field">
                  <input
                    class="is-checkradio is-circle is-success"
                    id="covidchecklistYes"
                    type="radio"
                    value={YES}
                    bind:group={covidChecklistSelected}
                    name="covidchecklist" />
                  <label for="covidchecklistYes">{YES}</label>
                  <input
                    class="is-checkradio is-circle is-success"
                    id="covidchecklistNo"
                    type="radio"
                    value={NO}
                    bind:group={covidChecklistSelected}
                    name="covidchecklist" />
                  <label for="covidchecklistNo">{NO}</label>
                </div>
                {#if !covidChecklistValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              -->
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>
                    Did the resident(s) learn about a local hazard?
                  </strong>
                </label>
                <span style="color:blue">
                  <small>
                    <i>
                      If yes select the hazard type; if no, select None. Home
                      fire safety education should not be reported in this
                      field.
                    </i>
                  </small>
                </span>
                <br />
                <div class="select">
                  <select bind:value={localHazardTypeSelected}>
                    {#each hazardValuesDropdown as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !localHazardTypeValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />

              <!-- Starts New Pilot Program -->
              {#if serviceTypeSelected === PILOT_PROGRAM && pilotStatus === 1 && pilotCode === PILOT_CODE.WILDFIRE}
                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did the resident(s) learn about wildfires and what steps
                      they can take to prepare?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="wildfireLearnYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireLearnSelected}
                      name="wildfireLearn"
                    />
                    <label for="wildfireLearnYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="wildfireLearnNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireLearnSelected}
                      name="wildfireLearn"
                    />
                    <label for="wildfireLearnNo">{NO}</label>
                  </div>
                  {#if !isWildfireLearnValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did the resident(s) learn about or create an evacuation
                      plan?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireEvacuationPlanYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireEvacuationPlanSelected}
                      name="wildfireEvacuationPlan"
                    />
                    <label for="isWildfireEvacuationPlanYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireEvacuationPlanNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireEvacuationPlanSelected}
                      name="wildfireEvacuationPlan"
                    />
                    <label for="isWildfireEvacuationPlanNo">{NO}</label>
                  </div>
                  {#if !isWildfireEvacuationPlanValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did the resident(s) learn about defensible space?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireDefensibleSpaceYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireDefensibleSpaceSelected}
                      name="wildfireDefensibleSpace"
                    />
                    <label for="isWildfireDefensibleSpaceYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireDefensibleSpaceNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireDefensibleSpaceSelected}
                      name="wildfireDefensibleSpace"
                    />
                    <label for="isWildfireDefensibleSpaceNo">{NO}</label>
                  </div>
                  {#if !isWildfireDefensibleSpaceValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did the resident(s) sign up for a local alert?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireSignUpAlertYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireSignUpAlertSelected}
                      name="wildfireSignUpAlert"
                    />
                    <label for="isWildfireSignUpAlertYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireSignUpAlertNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireSignUpAlertSelected}
                      name="wildfireSignUpAlert"
                    />
                    <label for="isWildfireSignUpAlertNo">{NO}</label>
                  </div>
                  {#if !isWildfireSignUpAlertValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did the resident(s) receive a weather radio?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireWeatherRadioYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireWeatherRadioSelected}
                      name="wildfireWeatherRadio"
                    />
                    <label for="isWildfireWeatherRadioYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireWeatherRadioNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireWeatherRadioSelected}
                      name="wildfireWeatherRadio"
                    />
                    <label for="isWildfireWeatherRadioNo">{NO}</label>
                  </div>
                  {#if !isWildfireWeatherRadioValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did the resident(s) receive a wildfire magnet?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireMagnetYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireMagnetSelected}
                      name="wildfireMagnet"
                    />
                    <label for="isWildfireMagnetYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireMagnetNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireMagnetSelected}
                      name="wildfireMagnet"
                    />
                    <label for="isWildfireMagnetNo">{NO}</label>
                  </div>
                  {#if !isWildfireMagnetValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did the resident(s) request any education or service that
                      was not covered in the visit?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireRequestServiceYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireRequestServiceSelected}
                      name="wildfireRequestService"
                    />
                    <label for="isWildfireRequestServiceYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireRequestServiceNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireRequestServiceSelected}
                      name="wildfireRequestService"
                    />
                    <label for="isWildfireRequestServiceNo">{NO}</label>
                  </div>
                  {#if !isWildfireRequestServiceValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                {#if !isEmptyOrCero(wildfireRequestServiceSelected) && wildfireRequestServiceSelected === YES}
                  <div class="slider" transition:slide>
                    <TextInput
                      id="wildfireService"
                      label="If yes, what service(s)?"
                      comment="Add service(s)"
                      placeholder=""
                      disableRequiredAsterisk={wildfireServiceValid}
                      valid={!wildfireServiceValid && isSaveTriggered}
                      validityMessage={REQUIRED_INFORMATION_MESSAGE}
                      value={wildfireService}
                      on:input={(event) =>
                        (wildfireService = event.target.value)}
                    />
                  </div>
                  <br />
                {/if}

                <br />

                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Did you refer this household to a mitigation partner?
                    </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireReferHouseholdYes"
                      type="radio"
                      value={YES}
                      bind:group={wildfireReferHouseholdSelected}
                      name="wildfireReferHousehold"
                    />
                    <label for="isWildfireReferHouseholdYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isWildfireReferHouseholdNo"
                      type="radio"
                      value={NO}
                      bind:group={wildfireReferHouseholdSelected}
                      name="wildfireReferHousehold"
                    />
                    <label for="isWildfireReferHouseholdNo">{NO}</label>
                  </div>
                  {#if !isWildfireReferHouseholdValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />

                {#if !isEmptyOrCero(wildfireReferHouseholdSelected) && wildfireReferHouseholdSelected === YES}
                  <div class="slider" transition:slide>
                    <TextInput
                      id="wildfireReferPartner"
                      label="If yes, what partner?"
                      comment="Add partner"
                      placeholder=""
                      disableRequiredAsterisk={wildfireReferPartnerValid}
                      valid={!wildfireReferPartnerValid && isSaveTriggered}
                      validityMessage={REQUIRED_INFORMATION_MESSAGE}
                      value={wildfireReferPartner}
                      on:input={(event) =>
                        (wildfireReferPartner = event.target.value)}
                    />
                  </div>
                  <br />
                {/if}
              {/if}

              {#if serviceTypeSelected === PILOT_PROGRAM && pilotStatus === 1 && pilotCode === PILOT_CODE.SAFEGIVE}
                <div class="slider" transition:slide>
                  <label class="required">
                    <strong> Were the installations verified? </strong>
                  </label>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isInstallationsVerifiedYes"
                      type="radio"
                      value={YES}
                      bind:group={installationsVerifiedSelected}
                      name="installationsVerified"
                    />
                    <label for="isInstallationsVerifiedYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="isInstallationsVerifiedNo"
                      type="radio"
                      value={NO}
                      bind:group={installationsVerifiedSelected}
                      name="installationsVerified"
                    />
                    <label for="isInstallationsVerifiedNo">{NO}</label>
                  </div>
                  {#if !isInstallationsVerifiedValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />
              {/if}

              <!-- Ends New Pilot Program -->

              <div class="slider" transition:slide>
                <TextInput
                  id="documenterName"
                  label="Paper Service Acknowledgment Form Completed by (First
                  and Last Name)"
                  comment="Reference Red Cross/Partner Printed Name"
                  valid={!documenterNameValid && isSaveTriggered}
                  validityMessage={REQUIRED_INFORMATION_MESSAGE}
                  value={documenterName}
                  on:input={(event) => (documenterName = event.target.value)}
                />
              </div>
              <br />
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>What date did the client receive services?</strong>
                </label>
                <span style="color:blue">
                  <small>
                    <i>(mm/dd/yyyy)</i>
                  </small>
                </span>
                <br />
                <Datepicker
                  buttonBackgroundColor="#eee3e1"
                  buttonTextColor="#661a0c"
                  highlightColor="#68bd21"
                  dayBackgroundColor="#eff9f5"
                  dayTextColor="#58070e"
                  dayHighlightedBackgroundColor="#58b518"
                  dayHighlightedTextColor="#0b457a"
                  selected={selectedDate}
                  end={new Date()}
                  bind:formattedSelected={serviceDate}
                  bind:dateChosen={isServiceDateChosen}
                >
                  <button class={calendarButtonColor} on:click|preventDefault>
                    {#if isServiceDateChosen}
                      Chosen: {serviceDate}
                    {:else}Pick a date{/if}
                  </button>
                </Datepicker>
              </div>
              {#if (!isServiceDateChosen && isSaveTriggered) || (isServiceDateChosen && !isvalidDate)}
                <p class="error-message">{calendarInformationMessage}</p>
              {/if}
              <br />
            </section>
          {/if}
        </div>
        <!-- Section 4 Home Assessment* -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[4].buttonColor}"
            on:click|preventDefault={() => expand(sections[4].id)}
          >
            <span style="font-weight:bold">{sections[4].title}</span>
            <span class="icon">
              {@html sections[4].buttonIcon}
            </span>
          </button>

          {#if !serviceProvidedValid && isSaveTriggered}
            <br />
            <p class="error-message">{REQUIRED_SERVICE_PROVIDED}</p>
            <br />
          {/if}

          {#if sections[4].active}
            <section class="section">
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>How many people live here?</strong>
                </label>
                <div class="select">
                  <select bind:value={peopleServedSelected}>
                    {#each numericDropDownValues(1, 14) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !peopleServedValid && isSaveTriggered}
                  <p class="error-message">{ERROR_PEOPLE_SERVED}</p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label>
                  <strong>How many youth ages 17 and under live here?</strong>
                </label>
                <div class="select">
                  <select bind:value={youthServedSelected}>
                    {#each numericDropDownValues(0, 14) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !youthServedValid && peopleServedValid && !isEmpty(youthServedSelected)}
                  <p class="error-message">
                    {YOUTH_SHOULD_NOT_BE_EQUAL_PEOPLE_SERVED}
                  </p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label>
                  <strong>How many adults ages 65 and older live here?</strong>
                </label>
                <div class="select">
                  <select bind:value={seniorsServedSelected}>
                    {#each numericDropDownValues(0, 14) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !seniorsServedValid && peopleServedValid && !isEmpty(seniorsServedSelected)}
                  <p class="error-message">
                    {SUM_YOU_THAN_SENIORS_NOT_GREATER_THAN}
                  </p>
                {/if} 
              </div>
              <br />
              <div class="slider" transition:slide>
                <label>
                  <strong>
                    How many individuals with a disability, access, or
                    functional need live here?
                  </strong>
                </label>
                <div class="select">
                  <select bind:value={idafnServedSelected}>
                    {#each numericDropDownValues(0, 14) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !idafnServedValid && peopleServedValid && !isEmpty(idafnServedSelected)}
                  <p class="error-message">{INDIVIDUALS_DISABILITIES}</p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label>
                  <strong>
                    How many veterans, military members, or military family
                    members live here?
                  </strong>
                </label>
                <div class="select">
                  <select bind:value={militaryServedSelected}>
                    {#each numericDropDownValues(0, 14) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !militaryServedValid && peopleServedValid && !isEmpty(militaryServedSelected)}
                  <p class="error-message">
                    {MILITARY_SHOULD_NOT_EXCEED_PEOPLESERVED}
                  </p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <label>
                  <strong>
                    How many pre-existing smoke alarms does the household
                    already have?
                  </strong>
                </label>
                <div class="select">
                  <select bind:value={preexistingAlarmsSelected}>
                    {#each numericDropDownValues(0, 9) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
              </div>
              <br />
              <div class="slider" transition:slide>
                <label>
                  <strong>
                    How many pre-existing smoke alarms were tested and working?
                  </strong>
                </label>
                <div class="select">
                  <select bind:value={preexistingAlarmsWorkingSelected}>
                    {#each numericDropDownValues(0, 9) as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !preexistingAlarmsWorkingValid && !isEmpty(preexistingAlarmsWorkingSelected)}
                  <p class="error-message">
                    {ALARMS_WORKING_EXCEED_PRE_EXISTING_ALARMS}
                  </p>
                {/if}
              </div>
              <br />
              {#if serviceTypeValid && serviceTypeSelected === REMOTE_HFC_SERVICE_DELIVERY}
                <div class="slider" transition:slide>
                  <label class="required">
                    <strong>
                      Does this client require additional follow-up due to
                      Remote HFC Service Delivery?
                    </strong>
                  </label>
                  <span style="color:blue">
                    <small>
                      <i>
                        If you select yes, please specify what follow-up is
                        needed in the Additional Notes field below.
                      </i>
                    </small>
                  </span>
                  <br />
                  <div class="field">
                    <input
                      class="is-checkradio is-circle is-success"
                      id="additionalFollowUpYes"
                      type="radio"
                      value={YES}
                      bind:group={additionalFollowUpSelected}
                      name="additionalFollowUp"
                    />
                    <label for="additionalFollowUpYes">{YES}</label>
                    <input
                      class="is-checkradio is-circle is-success"
                      id="additionalFollowUpNo"
                      type="radio"
                      value={NO}
                      bind:group={additionalFollowUpSelected}
                      name="additionalFollowUp"
                    />
                    <label for="additionalFollowUpNo">{NO}</label>
                  </div>
                  {#if !additionalFollowUpValid && isSaveTriggered}
                    <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                  {/if}
                </div>
                <br />
              {/if}
              <div class="slider" transition:slide>
                <TextInput
                  id="additionalNotes"
                  label="Additional Notes"
                  value={additionalNotes}
                  on:input={(event) => (additionalNotes = event.target.value)}
                />
              </div>
              <br />
            </section>
          {/if}
        </div>
        <!-- Section 5 Partner Reporting Fields* -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[5].buttonColor}"
            on:click|preventDefault={() => expand(sections[5].id)}
          >
            <span style="font-weight:bold">{sections[5].title}</span>
            <span class="icon">
              {@html sections[5].buttonIcon}
            </span>
          </button>

          {#if sections[5].active}
            <section class="section">
              <div class="slider" transition:slide>
                <label class="required">
                  <strong>National Coalition Organization</strong>
                </label>
                <div class="select">
                  <select bind:value={nationalPartnerSelected}>
                    {#each nationalPartnerTypeDropdown as value}
                      <option value={value.id}>{value.text}</option>
                    {/each}
                  </select>
                </div>
                {#if !nationalPartnerValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="localPartner"
                  label="Local Partner Organization Name(s)"
                  disableRequiredAsterisk={(localPartnerTypeSelected.length ===
                    1 &&
                    localPartnerTypeSelected.includes("none")) ||
                    localPartnerTypeSelected.length === 0}
                  valid={!localPartnerNameValid && isSaveTriggered}
                  validityMessage={REQUIRED_INFORMATION_MESSAGE}
                  value={localPartner}
                  on:input={(event) => (localPartner = event.target.value)}
                />
              </div>
              <br />

              <div class="slider" transition:slide>
                <label class="required">
                  <strong>Local Partner Type</strong>
                </label>
                <span style="color:blue">
                  <small>
                    <i>You may select more than one partner type, as needed.</i>
                  </small>
                </span>
                <br />
                {#each localPartnerTypeDropdown as value}
                  <div class="field">
                    <input
                      class="is-checkradio is-success"
                      id={value.id}
                      name={value.id}
                      type="checkbox"
                      bind:group={localPartnerTypeSelected}
                      value={value.id}
                    />
                    <label for={value.id}>{value.text}</label>
                  </div>
                {/each}
                {#if !localPartnerTypeValid && isSaveTriggered}
                  <p class="error-message">{REQUIRED_INFORMATION_MESSAGE}</p>
                {/if}
              </div>
            </section>
          {/if}
        </div>
        <!-- Section 6 Region Designated Reporting Fields -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[6].buttonColor}"
            on:click|preventDefault={sectionTouched(sections[6].id)}
          >
            <span style="font-weight:bold">{sections[6].title}</span>
            <span class="icon">
              {@html sections[6].buttonIcon}
            </span>
          </button>
          <div style="text-align: center">
            <span style="color:blue">
              <small>
                <i>
                  The Red Cross may direct volunteers and partners to report on
                  additional aspects of the campaign; these two fields can be
                  used to collect and track this data.
                </i>
              </small>
            </span>
          </div>
          {#if sections[6].active}
            <section class="section">
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="option1"
                  label="Optional 1."
                  value={option1}
                  on:input={(event) => (option1 = event.target.value)}
                />
              </div>
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="option2"
                  label="Optional 2."
                  value={option2}
                  on:input={(event) => (option2 = event.target.value)}
                />
              </div>
            </section>
          {/if}
        </div>
        <!-- Section 7 Information for Future Follow Up* -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[7].buttonColor}"
            on:click|preventDefault={sectionTouched(sections[7].id)}
          >
            <span style="font-weight:bold">{sections[7].title}</span>
            <span class="icon">
              {@html sections[7].buttonIcon}
            </span>
          </button>
          <div style="text-align: center">
            <span style="color:blue">
              <small>
                <i>
                  Clients are encouraged, but not required to provide contact
                  information.
                </i>
              </small>
            </span>
          </div>
          {#if sections[7].active}
            <section class="section">
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="homePhone"
                  label="Client's Home Phone"
                  type="tel"
                  onKeyUp={validateNumericHomePhone(homePhoneNumeric)}
                  value={homePhoneNumeric}
                  disableRequiredAsterisk="true"
                  valid={!homePhoneValid}
                  validityMessage={VALIDE_PHONE_MESSAGE}
                  on:input={(event) => (homePhoneNumeric = event.target.value)}
                />
              </div>
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="cellPhone"
                  label="Client's Cell Phone"
                  type="tel"
                  onKeyUp={validateNumericCellPhone(cellPhoneNumeric)}
                  value={cellPhoneNumeric}
                  disableRequiredAsterisk="true"
                  valid={!cellPhoneValid}
                  validityMessage={VALIDE_PHONE_MESSAGE}
                  on:input={(event) => (cellPhoneNumeric = event.target.value)}
                />
              </div>
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="email"
                  label="Client's Email"
                  value={email}
                  disableRequiredAsterisk="true"
                  valid={!emailValid}
                  validityMessage={VALIDE_MAIL_MESSAGE}
                  on:input={(event) => (email = event.target.value)}
                />
              </div>
            </section>
          {/if}
        </div>
        <!-- Section 8 Administrative Section* -->
        <div class="box accordion">
          <button
            class="button button-accordian {sections[8].buttonColor}"
            on:click|preventDefault={() => expand(sections[8].id)}
          >
            <span style="font-weight:bold">{sections[8].title}</span>
            <span class="icon">
              {@html sections[8].buttonIcon}
            </span>
          </button>

          {#if sections[8].active}
            <section class="section">
              <br />
              <div class="slider" transition:slide>
                <TextInput
                  id="dataEntryName"
                  label="Digital Record Submitted by (First and Last Name)"
                  value={dataEntryName}
                  onKeyUp={validateSection8(dataEntryName)}
                  valid={!dataEntryNameValid && isSaveTriggered}
                  validityMessage={REQUIRED_INFORMATION_MESSAGE}
                  on:input={(event) => (dataEntryName = event.target.value)}
                />
              </div>
              <br />
            </section>
          {/if}
        </div>
      </form>
      <br />
      <div>
        <button
          disabled={isSubmitted}
          class="button is-danger is-light"
          on:click={showDialog}
        >
          Cancel
        </button>
        <button
          disabled={isSubmitted}
          class="button is-danger {isLoading}"
          on:click={submit}
        >
          Submit Record
        </button>
        {#if !formIsValid && isSaveTriggered}
          <p class="error-message">{REVIEW_FIELDS_MARKED_RED}</p>
        {/if}
      </div>
    </div>
  </section>
</body>

<style>
  .button-accordian {
    width: 100%;
  }
  .error-message {
    color: red;
    margin: 0.25rem 0;
  }
  .required::after {
    color: red;
    content: " *";
  }

  .space {
    padding: 5px 5px;
  }
  .container-checkbox {
    padding: 8px 8px 8px;
    border: 1px solid #ccc;
    height: 17em;
    overflow-y: scroll;
  }
  .is-checkradio[type="checkbox"] + label {
    display: block;
  }
</style>
